<template>
  <q-btn-dropdown
    v-if="mode"
    :label="mode.label"
    :title="mode.label"
    v-bind="$attrs">
    <q-list dense>
      <q-item
        v-for="mode in modes"
        :key="mode.value"
        :active="modelValue === mode.value"
        clickable v-close-popup
        @click="change(mode.value)">
        <q-item-section>
          <q-item-label>{{ mode.label }}</q-item-label>
        </q-item-section>
      </q-item>
    </q-list>
  </q-btn-dropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface Mode {
  value: string,
  label: string
}
interface Data {
  modes: Mode[]
}

export default defineComponent({
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: String,
      default: 'scroll',
    },
  },
  data(): Data {
    return {
      modes: [
        {
          value: 'scroll',
          label: 'Continuous Scroll',
        },
        {
          value: 'manual',
          label: 'Page Scroll',
        },
      ],
    };
  },
  computed: {
    mode(): Mode|null {
      if (!this.modelValue) return null;
      return this.modes.find(m => m.value === this.modelValue) || null;
    },
  },
  methods: {
    change(value: string): void {
      this.$emit('update:modelValue', value);
    },
  },
});
</script>
